export default () => {
  const init = () => {

    class SearchForm extends HTMLElement {
      constructor() {
        super();

        this.querySelector('.search-form__btn').addEventListener('click', () => {
          this.submit();
        });

        this.querySelector('.search-form__btn').addEventListener('keyup', (event) => {
          if (event.key === 'Enter') {
            this.submit();
          }
        });
      }
    }

    customElements.define('search-form', SearchForm);
  };

  init();
};
